﻿import { get as getProjection, getPointResolution, METERS_PER_UNIT } from 'ol/proj';
import { getLength as getSphereLength, getArea as getSphereArea } from 'ol/sphere';
import * as defaults from './defaults';
import * as paths from './paths';
import * as formats from './formats';
import { transformExtent } from 'ol/proj';
import XGeoJSON from '../format/XGeoJSON';

export function addOption(options, option, value) {

    if (value != null) {
        value = typeof value == "string" ? value.trim() : value;
        options[option] = value;
    }
}

export function getResolutionForScale(scale, projectionId, center) {
    if (scale == null) {
        return null;
    }

    let units = getProjection(projectionId).getUnits();
    let dpi = 25.4 / 0.28;
    let mpu = METERS_PER_UNIT[units];
    let inchesPerMeter = 39.37;
    let resolution = scale / (mpu * inchesPerMeter * dpi);

    return resolution;
}

export function getScaleForResolution(resolution, projectionId, center) {
    if (resolution == null) {
        return null;
    }

    if (center) {
        resolution = parseFloat(getPointResolution(getProjection(projectionId), resolution, center).toString());
    }

    let units = getProjection(projectionId).getUnits();
    let default_dpi = 25.4 / 0.28;
    let mpu = METERS_PER_UNIT[units];
    let inchesPerMeter = 39.37;
    let scale = resolution * mpu * inchesPerMeter * default_dpi;

    return scale;
}

export function handleAnalysisLoader(layerSettings, map, rootUrl, source, selectionHandler, generalActionHandler) {
    const bbox = layerSettings.LoadingStrategy != "allStrategy";
    let loader = (extent, resolution, projection) => {
        let data = {
            geomFieldName: layerSettings.Entity.geomField,
            pkFieldName: layerSettings.Entity.pkField,
            analyse: layerSettings.Entity,
            srs: map.getView().getProjection().getCode()
        }

        if (bbox) {
            data.bbox = extent.join(',') + ',' + map.getView().getProjection().getCode();
        }
        //CG: fara filtru spatial analiza ruleaza o singura data, complet -> blocam cu loading pana termina
        else {
            showLoadingPanel();
        }

        $.ajax({
            type: "POST",
            url: rootUrl + paths.ANALYSIS_URL,
            async: true,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: (result) => {
                if (!bbox) {
                    hideLoadingPanel();
                }
                if (!result.Error) {
                    var formatOptions = {};

                    formatOptions.layerId = layerSettings.Id;

                    formatOptions.selectionHandler = selectionHandler;
                    formatOptions.generalActionHandler = generalActionHandler;
                    formatOptions.layerSettings = layerSettings;

                    if (layerSettings.Entity.geomField != null && layerSettings.Entity.geomField != '') {
                        formatOptions.geometryName = layerSettings.Entity.geomField;
                    }

                    var geoJsonFormat = new XGeoJSON(formatOptions);
                    let features = geoJsonFormat.readFeatures(result, {
                        extent: extent,
                        featureProjection: projection
                    });

                    source.addFeatures(features);
                }
            },
            error: (e) => {
                if (!bbox) {
                    hideLoadingPanel();
                }
            }
        });
    }

    return loader;
}

export function handleNativeUrl(mapId, layerSettings, map, rootUrl) {
    const bbox = layerSettings.LoadingStrategy != "allStrategy";

    if (layerSettings.url == null) {
        layerSettings.url = rootUrl + paths.MAP_GET_FEATURE_URL + '?layer=' + layerSettings.Id;
    }

    let urlFunction = (extent) => {
        let url = layerSettings.url;
        url += '&srs=' + map.getView().getProjection().getCode();

        if (bbox) {
            url += '&bbox=' + extent.join(',') + ',' + map.getView().getProjection().getCode();
        }

        if (layerSettings.Filters) {
            url += '&filter=' + JSON.stringify(layerSettings.Filters);
        }        
        url += '&idMap=' + mapId;
        return url;
    };

    return urlFunction;
}

export function handleGeoserverVectorTileLayerUrl(mapId, rootUrl, layerSettings, map, gisSettingsHandler) {
    var url = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + gisSettingsHandler.settings.VectorTile_URL.replaceAll("{Workspace}", gisSettingsHandler.settings.Workspace);
    url = url.replaceAll("{Layer}", defaults.ENTITY_TYPE_NAME_PREFIX + layerSettings.Id);
    url = url.replaceAll("{Projection}", map.getView().getProjection().getCode());
    var format = "application/vnd.mapbox-vector-tile";
    var _format = layerSettings.Format == null ? gisSettingsHandler.settings.VectorTile_Format : layerSettings.Format;
    switch (_format) {
        case "application/vnd.mapbox-vector-tile":
            format = "application/vnd.mapbox-vector-tile";
            break;
        case "application/json;type=geojson":
            format = "application/json;type=geojson";
            break;
        case "application/json;type=topojson":
            format = "application/json;type=topojson";
            break;
    }
    url = url.replace("{Format}", format);

    return url;
}

export function handleWfsUrl(mapId, rootUrl, layerSettings, map, gisSettingsHandler) {
    const path = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + gisSettingsHandler.settings.Wfs_URL.replaceAll("{Workspace}", gisSettingsHandler.settings.Workspace);
    const version = gisSettingsHandler.settings.Wfs_Version;
    const typeName = gisSettingsHandler.settings.Workspace + ':' + defaults.ENTITY_TYPE_NAME_PREFIX + layerSettings.Id;
    const outputFormat = layerSettings.Format == null ? gisSettingsHandler.settings.Wfs_DefaultFormat : layerSettings.Format;
    const projectionName = layerSettings.Entity.GeometrySrid;
    const bbox = layerSettings.LoadingStrategy != "allStrategy";

    let urlFunction = (extent) => {
        let url = path + '?service=WFS&request=GetFeature&version=' + version + '&typeName=' + typeName
            + '&outputFormat=' + outputFormat + '&srsname=' + projectionName;

        var _filters = "";

        if (layerSettings.WfsFilters) {
            for (var i = 0; i < layerSettings.WfsFilters.length; i++) {

                var _currentFilter = "";
                for (var j = 0; j < layerSettings.WfsFilters[i].vals.length; j++) {
                    if (_currentFilter != "") {
                        _currentFilter += " OR ";
                    }
                    _currentFilter += layerSettings.WfsFilters[i].field + " " + layerSettings.WfsFilters[i].op + " " + layerSettings.WfsFilters[i].vals[j].toString();
                }

                if (_filters != "") {
                    _filters += " AND ";
                }
                _filters += "(" + _currentFilter.trim() + ")";
            }
        }

        if (_filters != null && _filters != "") {

            if (bbox && extent.length > 0) {
                url += '&CQL_FILTER= BBOX(' + layerSettings.Entity.GeometryFieldName + ',' + extent.join(',') + ") and (" + _filters + ")";
            }
            else {
                url += "&CQL_FILTER=" + _filters;
            }
        }
        else if (bbox && extent != null && extent.length > 0) {
            if (map.getView().getProjection().getCode() != projectionName) {
                extent = transformExtent(extent, map.getView().getProjection().getCode(), projectionName);
            }

            url += '&bbox=' + extent.join(',') + ',' + projectionName;
        }

        return url;
    };

    return urlFunction;
}

export function handleGeoserviceGeojsonWfsUrl(mapId, rootUrl, layerSettings, map) {
    let path;

    if (layerSettings.Geoservice.RequestUrl.indexOf('http') == 0) {
        path = layerSettings.Geoservice.RequestUrl;
    } else if (layerSettings.Geoservice.gsproxy) {
        path = rootUrl + paths.GSPROXY_URL + mapId + '/' + layerSettings.Geoservice.Id + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    } else {
        path = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    }

    let urlFunction = (extent) => {
        return substituteGeojsonFilterTokens(path, layerSettings.GeojsonFilterTokens);
    };

    return urlFunction;
}

// Inlocuieste token-urile {NumeCamp} din query string-ul unui geoservice GEOJSON cu valorile de filtru.
// Conventie: token == EntityField.FieldName. Valorile sunt deja formatate si vin gata de inlocuit din notifyFilters.
// Inlocuim DOAR in query string (dupa '?'), pentru ca verificarea din proxy (VerifyGeoserviceGeojsonRequest) compara doar path-ul.
// Token-urile nealimentate (fara valoare) sunt eliminate impreuna cu parametrul lor, ca sa nu trimitem 'param={NumeCamp}' la serviciul extern.
export function substituteGeojsonFilterTokens(url, tokens) {
    if (url == null) {
        return url;
    }

    let questionIdx = url.indexOf('?');

    // fara query string -> nimic de inlocuit (token-urile sunt suportate doar in query)
    if (questionIdx < 0) {
        return url;
    }

    let basePath = url.substring(0, questionIdx);
    let query = url.substring(questionIdx + 1);

    // separam query-ul in parametri ca sa putem elimina complet parametrii cu token nealimentat
    let keptParams = [];

    query.split('&').forEach((param) => {
        if (param === '') {
            return;
        }

        let resolved = param.replace(/\{([^{}]+)\}/g, (match, token) => {
            if (tokens != null && Object.prototype.hasOwnProperty.call(tokens, token) && tokens[token] != null) {
                return tokens[token];
            }
            return match;
        });

        // daca dupa inlocuire au mai ramas token-uri nerezolvate, parametrul nu are valoare -> il scoatem
        if (/\{[^{}]+\}/.test(resolved)) {
            return;
        }

        keptParams.push(resolved);
    });

    return keptParams.length > 0 ? basePath + '?' + keptParams.join('&') : basePath;
}

export function handleGeoserviceWfsUrl(mapId, rootUrl, layerSettings, map) {
    let path;

    if (layerSettings.Geoservice.RequestUrl.indexOf('http') == 0) {
        path = layerSettings.Geoservice.RequestUrl;
    } else if (layerSettings.Geoservice.gsproxy) {
        path = rootUrl + paths.GSPROXY_URL + mapId + '/' + layerSettings.Geoservice.Id + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    } else {
        path = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    }

    const version = layerSettings.Geoservice.Version != null ? layerSettings.Geoservice.Version : defaults.WFS_VERSION;
    const typeName = layerSettings.Geoservice.LayerName;
    const outputFormat = layerSettings.Format == null ? formats.DEFAULT_WFS_FORMAT : layerSettings.Format;
    const projectionName = layerSettings.Geoservice.TileMatrix;
    const bbox = layerSettings.LoadingStrategy != "allStrategy" && layerSettings.Geoservice.ServiceType != 'GEOJSON';

    let urlFunction = (extent) => {
        let url = path + '?service=WFS&request=GetFeature&version=' + version + '&typeName=' + typeName
            + '&outputFormat=' + outputFormat + '&srsname=' + projectionName;

        if (bbox) {
            if (map.getView().getProjection().getCode() != projectionName) {
                extent = transformExtent(extent, map.getView().getProjection().getCode(), projectionName);
            }

            url += '&bbox=' + extent.join(',') + ',' + projectionName;
        }
        return url;
    };

    return urlFunction;
}

export function isDesktop() {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']

    if (/Android/.test(userAgent)) {
        return false;
    }

    if (iosPlatforms.indexOf(platform) !== -1) {
        return false;
    }

    return true;
}

//CG: pe un CRS proiectat cu unitati reale masuram planar (distanta din retea, ca la cadastru);
//CG: pe grade sau pe Mercator (metri "umflati") singura varianta corecta ramane calculul sferic.
const PLANAR_DISTORTION_TOLERANCE = 0.01;

function canMeasurePlanar(projection, coordinate) {
    if (projection == null || coordinate == null || projection.getUnits() == 'degrees') {
        return false;
    }

    let metersPerUnit = projection.getMetersPerUnit();

    if (!metersPerUnit) {
        return false;
    }

    let pointResolution = getPointResolution(projection, 1, coordinate);

    if (!(pointResolution > 0)) {
        return false;
    }

    return Math.abs(pointResolution / metersPerUnit - 1) <= PLANAR_DISTORTION_TOLERANCE;
}

export function measureLength(geometry, projectionId) {
    let projection = getProjection(projectionId);

    if (canMeasurePlanar(projection, geometry.getFirstCoordinate())) {
        return geometry.getLength() * projection.getMetersPerUnit();
    }

    return getSphereLength(geometry, { projection: projection || defaults.DEFAULT_SRID });
}

export function measureArea(geometry, projectionId) {
    let projection = getProjection(projectionId);

    if (canMeasurePlanar(projection, geometry.getFirstCoordinate())) {
        let metersPerUnit = projection.getMetersPerUnit();
        return geometry.getArea() * metersPerUnit * metersPerUnit;
    }

    return getSphereArea(geometry, { projection: projection || defaults.DEFAULT_SRID });
}

export function measureCircleArea(circle, projectionId) {
    let projection = getProjection(projectionId);
    let center = circle.getCenter();
    let planarArea = Math.PI * circle.getRadius() * circle.getRadius();

    if (canMeasurePlanar(projection, center)) {
        let metersPerUnit = projection.getMetersPerUnit();
        return planarArea * metersPerUnit * metersPerUnit;
    }

    //CG: raza e in unitati distorsionate (Mercator/grade); o aducem la metri pe teren
    let metersPerUnit = projection != null ? getPointResolution(projection, 1, center, 'm') : null;

    return metersPerUnit > 0 ? planarArea * metersPerUnit * metersPerUnit : planarArea;
}

//CG: inversul masuratorilor de mai sus: metri pe teren -> unitati de harta in jurul coordonatei
export function metersToMapUnits(meters, projectionId, coordinate) {
    let projection = getProjection(projectionId);

    if (canMeasurePlanar(projection, coordinate)) {
        return meters / projection.getMetersPerUnit();
    }

    let metersPerUnit = projection != null ? getPointResolution(projection, 1, coordinate, 'm') : null;

    return metersPerUnit > 0 ? meters / metersPerUnit : meters;
}
